import { Language } from '../../../core/i18n/constants';
import { BASE_BACKEND_URL } from '../../backend/constants';
import { useAnonymousMutation } from '../../backend/hooks/use-anonymous-mutation';
import { AnonymousFormSendResponse, FormRequestBody } from '../../backend/openapi/api-types';

export const useAnonymousSendFormRequest = (currentLanguage: Language) => {
  const url = `${BASE_BACKEND_URL}/request-forms/anonymous-send-form`;
  const mutationParams = {
    method: 'POST',
    url: url,
    language: currentLanguage,
  } as const;

  return useAnonymousMutation<AnonymousFormSendResponse, FormRequestBody>(mutationParams);
};
